import React, { useState } from 'react';
import { IDriver } from '../../models/Driver.model';
import { Grid, GridColumn, GridNoRecords } from '@progress/kendo-react-grid';
import { Checkbox } from 'primereact/checkbox';
import CommandCell from '../userAdmin/CommandCell';
import { process, State } from '@progress/kendo-data-query';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import { locale } from '../../common/localization/localizationService';

export interface IDriversGridProps {
  data: Array<IDriver>;
  className?: string;
  editDriver: (dataItem: IDriver) => void;
  deleteDriver: (dataItem: IDriver) => void;
}

export default function DriversGrid(props: IDriversGridProps): JSX.Element {
  const { editDriver, deleteDriver } = props;

  const [dataState, setDataState] = useState<State>({
    sort: [
      {
        dir: 'asc',
        field: 'driver',
      },
    ],
    take: 26,
    skip: 0,
  });

  const dataStateChange = (event: Record<string, any>): void => {
    setDataState(event.data);
  };

  const ActiveCell = (gridProps: any) => {
    return (
      <td className="driver-active-cell">
        <Checkbox checked={gridProps.dataItem.active} disabled />
      </td>
    );
  };

  const EditCell = (props: any): JSX.Element => {
    return <CommandCell {...props} edit={editDriver} icon={faEdit} />;
  };

  const DeleteCell = (props: any): JSX.Element => {
    return <CommandCell {...props} edit={deleteDriver} icon={faTrash} />;
  };
  const result = process(props.data, dataState);

  return (
    <>
      <Grid
        {...dataState}
        className="drivers-grid"
        data={result}
        pageable
        resizable
        sortable
        pageSize={26}
        onDataStateChange={dataStateChange.bind(this)}
      >
        <GridNoRecords>{locale.drivers._noDrivers}</GridNoRecords>
        <GridColumn field="driver" title={locale.drivers._driver} filterable />
        <GridColumn
          field="firstName"
          title={locale.drivers._firstName}
          filterable
        />
        <GridColumn
          field="lastName"
          title={locale.drivers._lastName}
          filterable
        />
        <GridColumn field="phone" title={locale.drivers._phoneNr} filterable />
        <GridColumn
          field="active"
          title={locale.drivers._active}
          filterable
          width={95}
          cell={ActiveCell}
        />
        <GridColumn width={34} cell={EditCell} sortable={false} />
        <GridColumn width={34} cell={DeleteCell} sortable={false} />
      </Grid>
    </>
  );
}
